module.exports = __webpack_public_path__ + "static/media/FooterLogo.170941da.png";